export const initiativeTabs = {
  overview: 'overview',
  thread: 'thread',
} as const
